import React from 'react';
import { Card, Switch, Space, Typography, theme } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { useThemeStore } from '../../../store/theme.store';

const { Title, Text } = Typography;

export function ImportantTab() {
    const { token } = theme.useToken();
    const { isProfessionalMode, toggleProfessionalMode } = useThemeStore();

    return (
        <div style={{ maxWidth: 800 }}>
            <Card
                title={
                    <Space>
                        <WarningOutlined style={{ color: token.colorWarning }} />
                        <span>Ważne ustawienia</span>
                    </Space>
                }
                headStyle={{ borderBottom: `1px solid ${token.colorBorderSecondary}` }}
            >
                <div style={{ padding: '8px 0' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
                        <div>
                            <Title level={5} style={{ margin: 0 }}>Tryb Profesjonalny</Title>
                            <Text type="secondary">
                                Włącza dodatkowe funkcje wizualne i interaktywne dla zaawansowanych użytkowników.
                            </Text>
                        </div>
                        <Switch
                            checked={isProfessionalMode}
                            onChange={toggleProfessionalMode}
                            checkedChildren="WŁĄCZONY"
                            unCheckedChildren="WYŁĄCZONY"
                        />
                    </div>
                </div>
            </Card>
        </div>
    );
}
